import { PayloadAction } from '@reduxjs/toolkit';
import { call, put } from 'typed-redux-saga';

import {
    NotificationItem,
    NOTIFICATIONS_MAP,
    NotificationType,
    notify,
} from '../../../../../shared/features/notifications/ps-notifications';
import { i18n } from '../../../../../shared/helpers/i18n';
import { countMetrika } from '../../../../../shared/helpers/metrika';
import { replace, SCREENS } from '../../../../../shared/helpers/navigation';
import { NotificationId } from '../../../../call/types';
import { PlanCallErrorPayload, PlanCallPayload } from '../slice';

/**
 * Обработчик успеха при планировании события
 * Возвращаем на главную и показываем уведомление
 *
 * @yields Generator
 */
export function* onSuccessPlanningSaga({
    payload: { url, sessionId, isBroadcast },
}: PayloadAction<PlanCallPayload>): Generator {
    const notification = NOTIFICATIONS_MAP[NotificationId.PLAN_CALL_SUCCESS](Boolean(isBroadcast), url);

    countMetrika('main_screen', 'planning_screen', 'create', sessionId);

    yield* call(replace, SCREENS.CREATE_CALL, {});
    yield* put(notify(notification));
}

/**
 * Обработчик ошибок при планировании события
 * Возвращаем на главную и показываем ошибку
 *
 * @yields Generator
 */
export function* onErrorPlanningSaga({ payload: { isBroadcast } }: PayloadAction<PlanCallErrorPayload>): Generator {
    const notification: NotificationItem = {
        id: NotificationId.PLAN_CALL_ERROR,
        text: isBroadcast ? i18n('plan-call', 'error-planned-broadcast') : i18n('plan-call', 'error-planned-call'),
        type: NotificationType.ERROR,
        icon: 'error',
        timeout: 3000,
    };

    yield* call(replace, SCREENS.CREATE_CALL, {});
    yield* put(notify(notification));
}
